// this is from: https://snazzymaps.com
//https://snazzymaps.com/style/15/subtle-grayscale
const mapStyles = [
  {
    "featureType":"administrative",
    "elementType":"all",
    "stylers":[
      {
        "saturation":"-100"
      }
    ]
  },
  {
    "featureType":"administrative.province",
    "elementType":"all",
    "stylers":[
      {
        "visibility":"off"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      { "visibility": "off" }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [
      {
          "visibility": "on"
      },
      {
          "lightness": "46"
      },
      {
          "saturation": "-75"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
          "visibility": "off"
      }
    ]
  },






  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
          "visibility": "simplified"
      },
      {
          "color": "#c9c9c9"
      }
    ]
  },

  {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [
      {
          "visibility": "simplified"
      },
      {
          "color": "#a1b7ba"
      },
    ]
  },


  {
    "featureType": "poi",
    "elementType": "labels.icon",
    "stylers": [
      {
          "visibility": "off"
      }
    ]
  },






  {
    "featureType":"road",
    "elementType":"all",
    "stylers":[
      {
        "color":"#E5C573"
      }
    ]
  },
  {
    "featureType":"road.highway",
    "elementType":"all",
    "stylers":[
      {
        "visibility":"simplified"
      },
      {
        "lightness":"30"
      }

    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
        {
            "visibility": "off"
        }
    ]
  },

  {
    "featureType": "road",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "visibility": "simplified"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },


{
        "featureType": "road.arterial",
        "elementType": "all",
        "stylers": [
            {
                "lightness": "30"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },





  {
    "featureType":"transit",
    "elementType":"all",
    "stylers":[
      {
        "visibility":"off"
      }
    ]
  },
  {
    "featureType":"water",
    "elementType":"geometry",
    "stylers":[
      {
        "color": "#cbdae3"
      },
    ]
  },
  {
    "featureType":"water",
    "elementType":"labels",
    "stylers":[
      {
        "lightness":-25
      },
      {
        "saturation":-100
      }
    ]
  }
];

export default mapStyles;
